export default __webpack_public_path__ + "static/media/fatture.b65f451e.svg";